import React, { Component } from 'react';
import { AgGridReact } from 'ag-grid-react';
import { Loader } from 'semantic-ui-react';

import { ACTION_STATUS } from '../../../../utils/ActionStatus';
import BaseUrlConfig from '../../../../net/BaseUrlConfig';
import UrlConfig from '../../../../net/UrlConfig';

class LicenseGrid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      columnDefs: [
        {
          field: 'id',
          headerName: 'ID',
          cellClass: 'non-number',
          width: 90,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
        },
        { field: 'employee', headerName: 'Employee', cellClass: 'non-number', width: 160 },
        { field: 'registration', headerName: 'Regulator', cellClass: 'non-number', width: 150 },
        { field: 'country', headerName: 'Country', cellClass: 'non-number', width: 110 },
        {
          field: 'license',
          headerName: 'License (updated)',
          cellClass: 'non-number',
          width: 150,
          cellStyle: this.licenseCellStyle,
        },
        { field: 'role', headerName: 'Role', cellClass: 'non-number', width: 140 },
        { field: 'licenseNo', headerName: 'License No', cellClass: 'non-number', width: 140 },
        { field: 'licenseDate', headerName: 'License Date', cellClass: 'non-number', width: 130 },
        { field: 'cessationDate', headerName: 'Cessation Date', cellClass: 'non-number', width: 140 },
        {
          field: 'examStatus',
          headerName: 'Exam Status (updated)',
          cellClass: 'non-number',
          width: 160,
          valueFormatter: this.examStatusValueFormatter,
          cellStyle: this.examStatusCellStyle,
        },
        {
          field: 'attachmentOriginName',
          headerName: 'Attachment',
          cellClass: 'non-number',
          width: 180,
          tooltipField: 'attachmentOriginName',
          cellRenderer: this.attachmentCellRenderer,
        },
        { field: 'lastUpdatedBy', headerName: 'Last Update By', cellClass: 'non-number', width: 140 },
        { field: 'lastUpdateTime', headerName: 'Last Update Time', cellClass: 'non-number', width: 170 },
      ],
      defaultColDef: {
        enableCellChangeFlash: true,
        minWidth: 50,
        sortable: true,
        filter: true,
        resizable: true,
      },
      rowSelection: 'multiple',
      context: { componentParent: this },
      statusBar: {
        statusPanels: [
          {
            statusPanel: 'agTotalAndFilteredRowCountComponent',
            align: 'left',
          },
          {
            statusPanel: 'agTotalRowCountComponent',
            align: 'center',
          },
          { statusPanel: 'agFilteredRowCountComponent' },
          { statusPanel: 'agSelectedRowCountComponent' },
        ],
      },
    };
  }

  attachmentCellRenderer = params => {
    const data = params.data || {};
    if (!data.attachment) {
      return '';
    }

    const link = document.createElement('a');
    link.innerText = data.attachmentOriginName || data.attachment;
    link.target = '_blank';
    link.href = `${BaseUrlConfig.api.REST_URL}${BaseUrlConfig.api.API_VERSION}${UrlConfig.DOWNLOAD_LICENSE_ATTACHMENT}/${data.attachment}`;
    return link;
  };

  licenseCellStyle = params => {
    if (params.value === 'To be obtained') {
      return { color: '#0070c0' };
    }
    return null;
  };

  examStatusValueFormatter = params => {
    if (params.value === 'Not passed') {
      return 'Not Passed';
    }
    return params.value;
  };

  examStatusCellStyle = params => {
    if (params.value === 'Not passed') {
      return { color: '#ff0000' };
    }
    if (params.value === 'Passed') {
      return { color: '#00b050' };
    }
    return null;
  };

  getRowNodeId = data => data.id;

  onSelectionChanged = event => {
    const rowNodeArray = event.api.getSelectedNodes();
    const selectedLicenseInfoArray = rowNodeArray.map(rowNode => rowNode.data);
    this.props.selectLicenseInfo(selectedLicenseInfoArray);
  };

  render() {
    const { loadLicenseInfoActionStatus, loadLicenseInfoResp } = this.props;
    const isLoading = loadLicenseInfoActionStatus === ACTION_STATUS.LOGINING;
    const rowData = loadLicenseInfoResp && Array.isArray(loadLicenseInfoResp.data)
      ? loadLicenseInfoResp.data
      : [];

    return (
      <div className="ag-theme-balham grid-wrapper">
        {isLoading ? (
          <Loader active content="Loading..." />
        ) : (
          <AgGridReact
            columnDefs={this.state.columnDefs}
            rowData={rowData}
            defaultColDef={this.state.defaultColDef}
            rowSelection={this.state.rowSelection}
            suppressRowClickSelection={true}
            suppressAggFuncInHeader={true}

            animateRows={true}
            deltaRowDataMode={false}
            sideBar={true}
            enableRangeSelection={true}
            getRowNodeId={this.getRowNodeId}
            context={this.state.context}
            statusBar={this.state.statusBar}
            onSelectionChanged={this.onSelectionChanged}
          />
        )}
      </div>
    );
  }
}

export default LicenseGrid;
